import { CONFIG } from '../config'
import { WEIXIN } from '../weixin'
import { QQ } from './qq'

var SHARE = {
    initConfigShare() {
        if(CONFIG.platform == 'qq') {
            QQ.initConfigShare();
        }else if(CONFIG.platform == 'wechat') {
            WEIXIN.initConfigShare();
        }
    }
}

export {
    SHARE
}
